import React from 'react';
import './styles.css';
import BasicButton from '../../components/BasicButton';
import FiltersContentLoader from '../../components/FiltersContentLoader';
import GridHistory from '../../components/GridHistory';
import HorizontalLoader from '../../components/HorizontalLoader';
import ListSearchMinimalContentLoader from '../../components/ListSearchMinimalContentLoader';
import PanelContainer from '../../components/PanelContainer';
import ENDPOINT from '../../constants/endpoints';
import ROUTE from '../../constants/route';
import {updateHistory} from '../../helpers/grid-history';
import withViewStatisticsAction from '../../hocs/withViewStatisticsAction';
import useApi from '../../hooks/useApi';
import {useGrid} from '../../hooks/useGrid';
import PageLayout from '../../layouts/PageLayout';
import BasicDialog from '../../scenes/Dialog/components/BasicDialog';
import ConfirmDialog from '../../scenes/Dialog/components/ConfirmDialog';
import FormDialog from '../../scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from '../../scenes/Dialog/components/ResponseErrorDialog';
import ShortlistShareDialog from '../../scenes/Dialog/components/ShortlistShareDialog';
import ShortlistForm from '../../scenes/Form/components/ShortlistForm';
import List from '../../scenes/List';
import ShortlistItem from '../../scenes/List/components/ShortlistItem';
import RecruiterShortlist from '../../scenes/RecruiterShortlist';
import ShortlistSearch from '../../scenes/RecruiterShortlist/components/ShortlistSearch';
import Sidebar from '../../scenes/Sidebar';
import InBoundsHistory from '../../scenes/Sidebar/components/InBoundsHistory';

const Shortlist = props => {
  const {
    history,
    match: {
      params: { tab = null },
    },
    viewStatisticsShortlist,
    pageTitle,
  } = props;

  const { post } = useApi();

  const grid = useGrid(ENDPOINT.COLLECTION.SHORTLIST, params => {
    updateHistory(history, params);
  });

  const onDelete = id => {
    ConfirmDialog({
      dismissWhenClose: true,
      bodyRender: 'Are you sure you want to delete this shortlist?',
    }).then(() =>
      post(
        ENDPOINT.ACTION.SHORTLIST.DELETE,
        { id },
        {
          handleError: response => ResponseErrorDialog({ response }),
          handleSuccess: () => {
            grid.actions.fetch();
          },
        }
      )
    );
  };

  const createNewShortlistHandler = () => {
    openShortlistForm();
  };

  const onEdit = data => {
    openShortlistForm(data);
  };

  const openShortlistForm = data => {
    FormDialog({
      title: `${data ? 'Edit' : 'Create New'} Shortlist`,
      popupStyles: {
        maxWidth: '550px',
      },
      compact: true,
      modeless: false,
      params: { data },
      form: (actions, params) => (
        <ShortlistForm actions={actions} params={params} />
      ),
    }).then(
      () => grid.actions.fetch(),
      response => ResponseErrorDialog({ response })
    );
  };

  const onShare = (id, name) => {
    ShortlistShareDialog({
      id,
      title: `Share ${name} Shortlist with:`,
    }).then(
      () => BasicDialog({ bodyRender: 'Changes were successfully saved' }),
      response => ResponseErrorDialog({ response })
    );
  };

  const onViewStatistics = id => {
    viewStatisticsShortlist(id);
  };

  const handleTabChange = value => {
    history.push(ROUTE.SEARCH_SHORTLIST + (value === 'my' ? '' : '/shared'));
  };

  const title = `${
    grid.data.params.shared ? `Shortlists Shared With Me ` : `My Shortlists`
  }`;

  return (
    <GridHistory
      history={history}
      grid={grid}
      initialParams={{ shared: tab ? 'Yes' : null }}
    >
      <PageLayout
        pageClass="shortlist-page"
        pageTitle={pageTitle}
        mainContent={
          <>
            {grid.data.init ? (
              <PanelContainer styles={{ marginBottom: '15px' }}>
                <div className="shortlist-page__header">
                  <h2 className="shortlist-page__title">
                    Create New Shortlist
                  </h2>
                  <div className="shortlist-page__action">
                    <BasicButton
                      btnWidth={200}
                      btnHeight={45}
                      btnFontWeight={600}
                      btnText="Create Now"
                      btnArrow={true}
                      btnBg="#fff"
                      btnHoverBg="#f40"
                      controlFunc={createNewShortlistHandler}
                    />
                  </div>
                </div>
                <div className="shortlist-page__search">
                  <ShortlistSearch
                    search={grid.data.params.search}
                    searchPlaceholder="Search Shortlist"
                    onSendSearchQueryHandler={grid.actions.search}
                    onTabSelectHandler={handleTabChange}
                    selectedTab={tab === 'shared' ? 'shared' : 'my'}
                  />
                </div>
              </PanelContainer>
            ) : (
              <ListSearchMinimalContentLoader />
            )}

            {grid.data.init &&
              (grid.data.isFetching ? (
                <div className="horizontal-loader__container">
                  <HorizontalLoader />
                </div>
              ) : (
                <RecruiterShortlist>
                  <div className="page__description">
                    <h3 className="page__subtitle">{title}</h3>
                  </div>
                  <List
                    items={grid.data.rows}
                    itemRender={item => (
                      <ShortlistItem
                        key={item.ShortlistID}
                        data={item}
                        isEditable={!grid.data.params.shared}
                        actions={{
                          onDelete,
                          onEdit,
                          onViewStatistics,
                          onShare,
                        }}
                      />
                    )}
                    actions={{
                      onChangePage: grid.actions.readPage,
                    }}
                    pagination={{
                      page: grid.data.page,
                      count: grid.data.rowsCount,
                      perPage: grid.data.perPage,
                    }}
                  />
                </RecruiterShortlist>
              ))}
          </>
        }
        sidebarContent={
          grid.data.init ? (
            <Sidebar>
              <InBoundsHistory isRecruiter />
            </Sidebar>
          ) : (
            <FiltersContentLoader />
          )
        }
      />
    </GridHistory>
  );
};

export default withViewStatisticsAction(Shortlist);
